import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../../services/auth-service.service';

@Injectable()
export class AppAuthGuard {
  constructor(protected authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const isLoggedIn = this.authService.isLoggedIn();
    const isAuthRoute = route.routeConfig?.path === 'auth';

    if (!isLoggedIn) {
      if (isAuthRoute) {
        return true;
      }
      this.router.navigate(['auth']);
      return false;
    }

    // Залогинен, но без роли экспедитора: закрываем доступ по старому токену (вошёл до внедрения
    // гейта) и после обновления токена, когда экранный гейт входа минуется. logout уводит на экран
    // входа и очищает недопустимую сессию.
    if (!this.authService.hasForwarderRole()) {
      this.authService.logout();
      return false;
    }

    if (!isAuthRoute) {
      return true;
    }
    this.router.navigate(['requests']);
    return false;
  }
}
